import React from "react";
import {
  Avatar,
  Button,
  CssBaseline,
  TextField,
  Typography,
  Container,
  Box,
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import * as authenticationApi from "../../api/authenticationApi";

class ForgotPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: { usernameOrEmail: "" },
      message: "",
      errors: {},
    };
  }

  onChange = (e) => {
    let errors = { ...this.state.errors };
    errors[e.target.name] = "";
    this.setState({ errors });

    const username = { ...this.state.username };
    username.usernameOrEmail = e.target.value;
    this.setState({ username });
  };

  formIsValid = () => {
    const { usernameOrEmail } = this.state.username;
    const errors = {};

    if (!usernameOrEmail) errors.usernameOrEmail = "Brukernavn er påkrevd";

    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  onSubmit = async (e) => {
    e.preventDefault();
    if (!this.formIsValid()) return;

    let username = this.state.username;
    let result = await authenticationApi.forgotPassword(username);

    if (result.ok) {
      this.setState({
        message: "Nytt passord ble sendt til registrert e-post.",
      });
    } else {
      this.setState({ message: JSON.parse(result).message });
    }
  };

  render() {
    return (
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 10,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: "primary.main" }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Glemt passord
          </Typography>
          <Box component="form" onSubmit={this.onSubmit} sx={{ mt: 3 }}>
            <TextField
              variant="outlined"
              margin="normal"
              fullWidth
              id="usernameOrEmail"
              label="Brukernavn"
              name="usernameOrEmail"
              value={this.state.username.usernameOrEmail}
              onChange={this.onChange}
              error={!!this.state.errors.usernameOrEmail}
              helpertext={this.state.errors.usernameOrEmail || ""}
              autoFocus
            />
            {this.state.message && (
              <Typography sx={{ color: "red", mt: 1 }}>{this.state.message}</Typography>
            )}
            <Button type="submit" fullWidth variant="contained" sx={{ mt: 2 }}>
              Send meg passord
            </Button>
          </Box>
        </Box>
      </Container>
    );
  }
}

export default ForgotPassword;
